import React, {useState, useEffect} from 'react';
import CustomInput from "components/CustomInput/CustomInput.js";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import CustomTabs from "happ-components/AgendaMedica/CustomTabs";
import Tasks from "happ-components/AgendaMedica/Tasks";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
const useStyles = makeStyles(styles);
const InputsAgenda = ({code}) => {
    const classes = useStyles();
    return ( 
        (() => {
            if ( code !== 'undefined' ) {
                switch (code) {
                    case 'presion-arterial':
                        return (
                            <GridContainer className="content-inputs-health-benefits">
                                <small className="params-text">Parametros del examen:</small>
                                <GridItem xs={6} sm={6} md={6}>
                                    <CustomInput
                                        labelText='Sistolica'
                                        id='sistolica_bi'
                                        name='sistolica_bi'
                                        formControlProps={{
                                            fullWidth: true,
                                        }}
                                        value=""
                                    />
                                </GridItem>
                                <GridItem xs={6} sm={6} md={6}>
                                    <CustomInput
                                        labelText='Diastolica'
                                        id='diastolica_bi'
                                        name='diastolica_bi'
                                        formControlProps={{
                                            fullWidth: true,
                                        }}
                                        value=""
                                    />
                                </GridItem>
                            </GridContainer>
                        )
                    case 'glicemia-ayunass':
                        return (
                            <GridContainer className="content-inputs-health-benefits">
                            <small className="params-text">Parametros del examen:</small>
                            <GridItem xs={12} sm={12} md={12}>
                                <CustomInput
                                    labelText="Glicemia"
                                    id="glicemia"
                                    value=""
                                    name="glicemia"
                                    formControlProps={{
                                        fullWidth: true,
                                    }}
                                />
                            </GridItem>
                        </GridContainer>
                        )
                    case 'perfil-lipidicoo':
                        return (
                            <GridContainer className="content-inputs-health-benefits">
                                <small className="params-text">Parametros del examen:</small>
                                <GridItem xs={6} sm={6} md={6}>
                                    <CustomInput
                                        labelText='Colesterol'
                                        id='colesterol'
                                        name='colesterol'
                                        formControlProps={{
                                            fullWidth: true,
                                        }}
                                        value=""
                                    />
                                </GridItem>       
                                <GridItem xs={6} sm={6} md={6}>
                                    <CustomInput
                                        labelText='Trigliceridos'
                                        id='trigliceridos'
                                        name='trigliceridos'
                                        formControlProps={{
                                            fullWidth: true,
                                        }}
                                        value=""
                                    />
                                </GridItem>                            
                            </GridContainer>
                        )        
                    default:
                        return null
                }
            }  else {
                return null;
            }
        })() 
    );
}
 
export default InputsAgenda;